import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearRoleState,
  getUserRole,
} from "../redux/slices/authenticationSlice";
import { useLocalStorage } from "./useLocalStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();
  const curentUserRole = useSelector(
    (state) => state.authentication.currentUserRole
  );
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    dispatch(getUserRole()).then((response) => {
      const admin = response.payload === "ROLE_ADMIN";
      setIsAdmin(admin);
    });
  }, [dispatch]);
  useEffect(() => {
    setIsAdmin(curentUserRole === "ROLE_ADMIN");
  }, [curentUserRole]);

  const login = async (data) => {
    setUser(data);
    dispatch(getUserRole()).then((response) => {
      const admin = response.payload === "ROLE_ADMIN";
      admin ? navigate("/admin/users") : navigate("/home/gift-page");
    });
  };

  const logout = () => {
    setUser(null);
    dispatch(clearRoleState());
    navigate("/login", { replace: true });
  };
  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      isAdmin,
    }),
    [user, isAdmin]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  return useContext(AuthContext);
};
